// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"2c279c46","703":"70e45a0c","787":"e08d770d"}[chunkId] + ".chunk.js";
};